export const DEFAULT_PROACTIVE_GREETING =
  'Hi there! I’d love to chat to see if there’s anything I can help with. If you have a second, press accept to be connected.';

export const DEFAULT_REACTIVE_GREETING =
  "Hi there! I'm happy to help. Hit accept to start talking with me, or you can just send messages here.";

export const BOT_AVATAR = 'https://uploads.servicebell.com/assets/bot-avatar.png';

export const EXTENSION_MARKER_ID = '__sb_extension_marker__';
